import {
  RenewalCredentials,
  RenewalDetails
} from '../components/common/CommonTypes';
import { CreateFromSuppressionRequest } from '../components/sitePages/suppression/types';
import { ApiHelper } from './apiHelper';

/**
 * Client-side API wrapper for renewals endpoints.
 */
export class RenewalsApi {
  /**
   * Retrieves renewal details using customer credentials.
   */
  getRenewalDetails(
    credentials: RenewalCredentials,
    token: string,
    successCallback: (data: RenewalDetails) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = '/api/renewals/getrenewaldetails';

    new ApiHelper().postDataSecureAsync(
      url,
      credentials,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  /**
   * Retrieves renewal details using a renewal record identifier.
   */
  getRenewalDetailsFromRecordId(
    request: {
      recordId: string;
      vrn: string;
      renewalSourceSystem: string;
      expAuthId: string;
      campaignId: string;
      brandName: string;
      culture: string;
      lateRenewalAllowedDays: number;
    },
    token: string,
    successCallback: (data: RenewalDetails) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const {
      recordId,
      vrn,
      renewalSourceSystem,
      expAuthId,
      campaignId,
      brandName,
      culture,
      lateRenewalAllowedDays
    } = request;
    const url = `/api/renewals/getrenewaldetailsfromrecordid?recordId=${recordId}&source=${renewalSourceSystem}&vrn=${vrn}&expAuthId=${expAuthId}&campaignid=${campaignId}&brandName=${brandName}&culture=${culture}&lateRenewalAllowedDays=${lateRenewalAllowedDays}`;

    new ApiHelper().getDataSecureAsync(
      url,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  createFromSuppression(
    suppressionDetails: CreateFromSuppressionRequest,
    successCallback: () => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = '/api/renewals/createfromsuppression';

    new ApiHelper().postDataAsync(
      url,
      suppressionDetails,
      successCallback,
      failureCallback,
      signal
    );
  }
}
